import React, { useEffect } from 'react';
import './App.css';

// Analytics
import mixpanel from 'mixpanel-browser';

// Redux
import { Provider } from 'react-redux';
import store from './store';

// Actions
import { loadUser } from './actions/authActions';

// Pages
import Help from './pages/Help';
import Pages_With_Navbar from './Pages_With_Navbar';

// Routing
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

const App = () => {

  // Initializing analytics
  const initializeAnalytics = () => {

    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
      debug: true
    });
  }

  // User Logic (load the user and initialize mixpanel tracking)
  useEffect(() => {
    // Dispatching the action to load the user
    store.dispatch(loadUser());

    // Analytics
    if (process.env.NODE_ENV === 'production') {
      initializeAnalytics();
    }

  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route exact path="/help" element={<Help />} />
          <Route exact path="/*" element={<Pages_With_Navbar />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
